import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';
import { BASE_URL } from '../constants/Url';
import logoQrCode from '../assets/images/logoQRCode.png';

function AppQRDownloadModal(props, ref) {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const showModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    return (
        <Modal
            centered
            open={open}
            onCancel={closeModal}
            footer={null}
            closeIcon={null}
            width={'32rem'}
            destroyOnClose={true}
            className="esi-wechat-qr-modal"
            styles={{
                content: {
                    borderRadius: '24px',
                    padding: 0,
                    overflow: 'hidden',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                },
            }}
        >
            <div className="relative p-6 sm:p-9 bg-white text-gray-800 flex flex-col items-center text-center">
                {/* Close Button */}
                <button
                    onClick={closeModal}
                    aria-label="Close"
                    className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full hover:bg-gray-100 focus:outline-none cursor-pointer z-10 flex items-center justify-center"
                >
                    <IoClose className="text-xl sm:text-2xl" />
                </button>

                {/* Header: Title & Subtitle */}
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-wide">
                    {t("text_wechat_official_account")}
                </h3>
                <p className="text-xs sm:text-sm text-gray-400 mt-1">
                    {t("text_wechat_scan_follow")}
                </p>

                {/* QR Code Container Card */}
                <div className="w-full max-w-[280px] sm:max-w-[310px] mt-5 sm:mt-6 p-4 sm:p-5 border border-gray-200/90 rounded-2xl flex flex-col items-center justify-center bg-white shadow-sm hover:border-gray-300 transition-colors">
                    <img
                        src={logoQrCode}
                        alt="WeChat Official Account QR"
                        className="w-48 sm:w-56 h-auto object-contain select-none"
                    />
                    <div className="flex items-center justify-center mt-3 sm:mt-4">
                        <img
                            src={BASE_URL + "/logo.svg"}
                            alt="易皓 ESIPRO"
                            className="h-5 sm:h-6 object-contain select-none"
                        />
                    </div>
                </div>

                {/* Footer Guidance Note */}
                <p className="text-xs sm:text-[13px] text-gray-400 mt-4 sm:mt-5 text-center leading-normal">
                    {t("text_wechat_scan_tip")}
                </p>
            </div>
        </Modal>
    );
}

export default forwardRef(AppQRDownloadModal);